import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { api } from '../../lib/api';
import type { Post } from '../../lib/types';
import { BlogLayout } from '../../components/BlogLayout';
import { HeroRail, PostGrid } from '../../components/PostFeed';
import { PageHeader } from '../../components/PageHeader';

export default function HomePage() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await api.get<Post[]>('/api/v1/posts');
        if (response.success && response.data) {
          setPosts(response.data);
        } else {
          setError(response.error?.message || 'Failed to load posts');
        }
      } catch (err) {
        setError('Failed to load posts');
        console.error('Error fetching posts:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, []);

  if (loading) {
    return (
      <BlogLayout>
        <Helmet>
          <title>QuestFlow - Automated Publishing</title>
          <meta name="description" content="Weekly dispatches on the flows, founders, and tools shaping work" />
        </Helmet>
        <div className="page-body">
          <PageHeader title="Flow Starts Here" eyebrow="Latest" />
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p className="placeholder">Loading posts...</p>
          </div>
        </div>
      </BlogLayout>
    );
  }

  if (error) {
    return (
      <BlogLayout>
        <Helmet>
          <title>QuestFlow - Automated Publishing</title>
          <meta name="description" content="Weekly dispatches on the flows, founders, and tools shaping work" />
        </Helmet>
        <div className="page-body">
          <PageHeader title="Flow Starts Here" eyebrow="Latest" />
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p className="placeholder" style={{ color: '#ef4444' }}>
              {error}
            </p>
          </div>
        </div>
      </BlogLayout>
    );
  }

  const heroPosts = posts.slice(0, 2);
  const gridPosts = posts.slice(2);

  return (
      <BlogLayout>
        <Helmet>
          <title>QuestFlow - Automated Publishing</title>
          <meta name="description" content="Weekly dispatches on the flows, founders, and tools shaping work" />
        </Helmet>
        <div className="page-body">
          <PageHeader title="Flow Starts Here" eyebrow="Latest" />
          {heroPosts.length > 0 && <HeroRail posts={heroPosts} />}
          {gridPosts.length > 0 && (
            <PostGrid posts={gridPosts} title="Latest Posts" ctaHref="/archive" ctaLabel="View all posts" />
          )}
          {posts.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <p className="placeholder">No posts yet - the first n8n publish will populate this feed.</p>
            </div>
          )}
        </div>
      </BlogLayout>
    );
  }
